const doc = [({"en":({"js":({"api_maker_bootstrap":({"live_table":({"filter":"Filter"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;